import { render, staticRenderFns } from "./EmailAnswer.vue?vue&type=template&id=7fde19fb&"
import script from "./EmailAnswer.vue?vue&type=script&lang=js&"
export * from "./EmailAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports